const searchFilterLabels = document.querySelectorAll('.searchFilters-label');
// console.log(searchFilterLabels);

searchFilterLabels.forEach( (labelButton) => {
  labelButton.addEventListener( 'click', searchFilterLabel_onClick, {passive: true} );
});

function searchFilterLabel_onClick(e){

  const this_button = e.currentTarget;
  const this_container = this_button.parentElement;
  const this_facet_list = this_button.nextElementSibling;

  jQuery(this_container).toggleClass('searchFilters-filter--isOpen');
  jQuery(this_facet_list).slideToggle('fast');

}